/* eslint-disable no-undef */
/* eslint-disable no-new */
( function () {
    const query         = ( selector, ctx = document ) => ctx.querySelector( selector );
    const query_all     = ( selector, ctx = document ) => ctx.querySelectorAll( selector );

    const cookie_footer_btn               = query( '#cookie_footer_btn' );
    const cookie_initial_modal            = query( '#cookie_initial_modal' );
    const cookie_settings_modal           = query( '#cookie_settings_modal' );
    const cookie_consent_decline          = query( '.jss_cookie_consent_decline' );
    const cookie_consent_settings         = query( '.jss_cookie_consent_settings' );
    const cookie_consent_agree            = query( '.jss_cookie_consent_agree' );
    const open_settings_modal             = query( '#jss_open_settings_modal' );
    const back_to_cookie_initial_modal    = query( '#jss_back_to_cookie_initial_modal' );
    const cookie_settings_modal_close_btn = query( '#jss_cookie_settings_modal_close_btn' );
    const consent_all_initial_modal       = query( '#jss_consent_all_initial_modal' );
    const consent_all_settings_modal      = query( '#jss_consent_all_settings_modal' );
    const consent_checked                 = query( '#jss_consent_checked' );
    const redirect_url                    = query_all( 'input[name="redirect_url"]' );
    const check_inputs                    = query_all( '.check-all' );
    const statistik                       = query( "input[name=statistik]" );
    const marketing                       = query( "input[name=marketing]" );
    const partner                         = query( "input[name=partner]" );

    const consent_status = cookie_footer_btn?.dataset.consentStatus;
    const consent_api_url = cookie_footer_btn?.dataset.consentApiUrl;

    const parseCookie = str =>
        str.split(';').map(v => v.split('=')).reduce((acc, v) => {
            acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
            return acc;
        }, {});

    const get_cookie = name => {
        const cookie_object = parseCookie(document.cookie);

        return cookie_object[name];
    };

    const prefill_from_stored_cookie = () => {
        let cookie_categories = get_cookie( 'cookiecookie' )?.split("_")[ 1 ].trim().split("") || [];

        cookie_categories.shift(); // ingore "necessary"

        check_inputs.forEach( ( input, idx ) => {
            input.checked = parseInt( cookie_categories[ idx ] ) === 1;
        });
    };

    redirect_url.forEach( elem => elem.value = window.location.href );

    const user_consent = () => {
        if ( consent_status !== '1' ) {
            const initial_modal = new bootstrap.Modal( cookie_initial_modal, {
                keyboard: false,
                backdrop: 'static'
            });
            new bootstrap.Modal( cookie_settings_modal, {
                keyboard: false,
                backdrop: 'static'
            });
            initial_modal.show();
            cookie_settings_modal_close_btn.classList.add('d-none');
            back_to_cookie_initial_modal.classList.remove('d-none');
        } else {
            prefill_from_stored_cookie();
        }
    };

    cookie_settings_modal.addEventListener('hide.bs.modal', () => {
        prefill_from_stored_cookie();
    });

    cookie_consent_decline.addEventListener('click', () => {
        document.initial_cookieform.action =`${ consent_api_url }1000`;

        return document.initial_cookieform.submit();
    });

    cookie_consent_settings.addEventListener('click', () => {
        open_settings_modal.click();
    });

    cookie_consent_agree.addEventListener('click', () => {
        consent_all_initial_modal.click();
    });

    consent_all_initial_modal.addEventListener('click', () => {
        document.initial_cookieform.action =`${ consent_api_url }1111`;

        return document.initial_cookieform.submit();
    });

    consent_all_settings_modal.addEventListener('click', () => {
        document.settings_cookieform.action = `${ consent_api_url }1111`;

        return document.settings_cookieform.submit();
    });

    function handle_checked_elements () {
        var agreed = '1';
        [ statistik, marketing, partner ].forEach( function ( checkbox ) {
            if ( checkbox.checked ) {
                agreed += '1';
            } else {
                agreed += '0';
            }
        });

        return agreed;
    }

    consent_checked.addEventListener('click', () => {
        document.settings_cookieform.action = `${ consent_api_url }${ handle_checked_elements() }`;

        return document.settings_cookieform.submit();
    });

    new bootstrap.Popover(query('.popover-dynamic-tooltip'), {
        content: query('#jss_popover-content-cookie').textContent,
        placement: 'auto'
    });

    user_consent();
})();
